export default __webpack_public_path__ + "static/media/correspondent11.b4cdb4fb.png";